import { render, staticRenderFns } from "./ManterSetoresView.vue?vue&type=template&id=ad999e5c"
import script from "./ManterSetoresView.vue?vue&type=script&lang=js"
export * from "./ManterSetoresView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports